import { render, staticRenderFns } from "./DishView.vue?vue&type=template&id=58d764e4&"
import script from "./DishView.vue?vue&type=script&lang=js&"
export * from "./DishView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports